import React from 'react';
import AppLayout from './layout/AppLayout';
import AppRouter from './routing/AppRouter';
import { SidebarProvider } from './contexts/SidebarContext';
import { LoadingProvider } from './contexts/LoadingContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AlertProvider } from './contexts/AlertProvider';
import { HeaderProvider } from './contexts/HeaderContext';
import { WorkspaceProvider } from './contexts/WorkspaceContext';
import ThemeConfigProvider from './components/ThemeConfigProvider';
// import './index.css'; // V2-specific CSS without custom.scss

const AppV2: React.FC = () => {
  return (
    <AlertProvider>
      <ThemeProvider>
        <ThemeConfigProvider>
          <LoadingProvider>
            <HeaderProvider>
              <SidebarProvider>
                <WorkspaceProvider>
                  <AppLayout>
                    <AppRouter />
                  </AppLayout>
                </WorkspaceProvider>
              </SidebarProvider>
            </HeaderProvider>
          </LoadingProvider>
        </ThemeConfigProvider>
      </ThemeProvider>
    </AlertProvider>
  );
};

export default AppV2;
